import { AnalyticsUTMParameter } from '@getaccept/lib-shared/src/types/analytics';

function getHubspotCookie() {
  if (document.cookie) {
    let pairs: any = /(?:^|; )hsfirstvisit=([^;\\|]*)/.exec(document.cookie) || [];
    if (pairs) {
      pairs = pairs.slice(1).pop();
      const hsfirstvisit = decodeURIComponent(pairs).substring(0, 100);
      if (hsfirstvisit !== 'undefined') {
        return hsfirstvisit;
      }
    }
  }
}

function getUTMParameterByName(name: AnalyticsUTMParameter) {
  const query = window.location.search.toString();
  const utmName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regexS = `[\\?&]${utmName}=([^&#]*)`;
  const regex = new RegExp(regexS);
  const results = regex.exec(query);
  if (results == null) {
    return;
  }
  return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getUTMData(): Partial<Record<AnalyticsUTMParameter, string>> | undefined {
  if (document.cookie) {
    const hsfirstvisit = getHubspotCookie();

    const utmData = {
      hsfirstvisit,
    };

    Object.values(AnalyticsUTMParameter).forEach(
      (param: AnalyticsUTMParameter) => (utmData[param] = getUTMParameterByName(param))
    );

    return utmData;
  }
}
